export default __webpack_public_path__ + "static/media/Baharr.4e15872a.svg";